import getQueryUtils, { attributeKeys } from './queryUtils';
import REQUIRED_FIELDS_PUBLIC_PROJECT from '@/pages/projects/REQUIRED_FIELDS_PUBLIC';
import REQUIRED_FIELDS_PUBLIC_EVENT from '@/pages/events/REQUIRED_FIELDS_PUBLIC';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4
  } = props;

  const queryUtils = getQueryUtils(search, attributeKeys);

  return useConnect('opportunity.find', {
    where: {
      eager: {
        $where: {
          $and: [
            ...queryUtils.where,
            {
              $or: [
                {
                  project: {
                    $where: {
                      $and: REQUIRED_FIELDS_PUBLIC_PROJECT.$and
                    }
                  }
                },
                {
                  event: {
                    $where: {
                      $and: REQUIRED_FIELDS_PUBLIC_EVENT.$and
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, { keepPreviousData : true });
}
